<template>
  <transition name="fade">
    <div class="row justify-content-center">
      <div class="col-lg-10 col-md-12 col-sm-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title bold">Well done, you may now provide your preferred loan amount</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Type of Loan</label>
                  <select class="form-control custom-select-sm" @change="selectLoanType(formLoanInfo.loan_type_id)" v-model="formLoanInfo.loan_type_id" :class="{'is-invalid': submitting && $v.formLoanInfo.loan_type_id.$error}">
                    <option selected disabled :value='null'>- Select -</option>
                    <option v-for="(i, k) in types" :value="i.id" :key="k">{{i.loan_type_desc}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Loan Facility</label>
                  <select disabled class="form-control custom-select-sm" v-model="formLoanInfo.loan_facility_id" :class="{'is-invalid': submitting && $v.formLoanInfo.loan_facility_id.$error}">
                    <option selected disabled :value='null'>- Select -</option>
                    <option v-for="(i, k) in facilities" :value="i.id" :key="k">{{i.loan_facility_desc}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Source of Funds for Repayment of Loans</label>
                  <select class="form-control custom-select-sm" v-model="formLoanInfo.fund_id" :class="{'is-invalid': submitting && $v.formLoanInfo.fund_id.$error}">
                    <option selected disabled :value='null'>- Select -</option>
                    <option v-for="(i, k) in sources" :value="i.id" :key="k">{{i.fund_source}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6" v-if="formLoanInfo.loan_type_id==1">
                <div class="form-group">
                  <label>Collaterals Offered</label>
                  <select class="form-control custom-select-sm" disabled v-model="formLoanInfo.coll_id">
                    <option selected disabled :value='null'>- Select -</option>
                    <option v-for="(i, k) in collaterals" :value="i.id" :key="k">{{i.collateral}}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12 alert alert-success2">
                <p class="card-text text-justify pb-0 mb-0">Your maximum loanable amount is <strong>Php {{formLoan.max_loan | curr}}</strong></p>
                <em class="card-text text-justify pb-0 mb-0"><strong>Note:</strong> Requested loan amount is subject to assessment and approval by SB Corporation.</em>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Loan Amount</label>
                  <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                      <span class="input-group-text" style="background-color: transparent !important;">&#8369</span>
                    </div>
                    <input type="number" v-model="formLoan.req_loan_amt" class="form-control" :class="{'is-invalid': submitting && $v.formLoan.req_loan_amt.$error}" />
                  </div>
                  <div>
                    <small class="text-muted float-right">{{convertedAmount}}</small>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>Loan Term (in months)</label>
                  <select class="form-control custom-select-sm" v-model="formLoan.req_loan_term" :class="{'is-invalid': submitting && $v.formLoan.req_loan_term.$error}" @change="changeLoanTerm">
                    <option :value='null' disabled>- Select -</option>
                    <option v-for="n in term" :value="n">{{ n }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Grace Period (in months)</label>
                  <select class="form-control" v-model="formLoan.grace_period" :class="{'is-invalid': submitting && $v.formLoan.grace_period.$error}">
                    <option :value='null' disabled>- Select -</option>
                    <option v-for="n in arrGracePeriod" :value="n">{{ n }}</option>
                  </select>
                </div>
              </div>


              <div class="col-md-4">
                <div class="form-group">
                  <label>Installment Period (in months)</label>
                  <input type="text" class="form-control" :value="install_fee" :readonly="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Interest Rate</label>
                  <div class="div-control">0% for the first twelve (12) months and<br />1% per month on the remaining months of the chosen loan term</div>
                </div>
              </div>
            </div>

          </div>
          <div class="card-footer">
            <button class="btn btn-primary" @click="$emit('back')"><i class="fas fa-arrow-left mr-1"></i>Back</button>
            <button class="btn btn-primary float-right" @click="next">Next<i class="fas fa-arrow-right ml-1"></i></button>
          </div>
        </div>
      </div>
      <div class="modal fade" id="modalFPA" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content pl-2">
            <div class="pb-4"></div>
            <div class="modal-body" v-if="formLoan.req_loan_amt > 300000 && formLoan.req_loan_amt <= 500000">
              <p class="card-text">The following shall be required for loan requests not more than PhP500.0 thousand during evaluation:</p>
              <div class="card-body mt-n3">
                <ul style="list-style: '-  '; margin-left: -20px;">
                  <li>Proof of sales including bank statements;</li>
                  <li>Joint and Solidary Signature (JSS) (for corporations and partnerships); and,</li>
                  <li>Proof of value of fixed asset/s to be acquired (if loan purpose is fixed asset acquisition).</li>
                </ul>
              </div>
            </div>

            <div class="modal-body" v-if="formLoan.req_loan_amt > 500000 && formLoan.req_loan_amt <= 3000000">
              <p class="card-text">The following shall be required for loan requests not more than PhP3.0 million during evaluation:</p>
              <div class="card-body mt-n3">
                <ul style="list-style: '-  '; margin-left: -20px;">
                  <li>Proof of sales including bank statements;</li>
                  <li>Joint and Solidary Signature (JSS) (for corporations and partnerships); and,</li>
                  <li>Proof of value of fixed asset/s to be acquired (if loan purpose is fixed asset acquisition).</li>
                  <li>Certificate of Securities and Exchange Commission (SEC) Registration; and,</li>
                  <li>Certificate of Department of Trade and Industry (DTI) Registration. </li>
                </ul>
              </div>
            </div>

            <div class="modal-body" v-if="formLoan.req_loan_amt > 3000000 && formLoan.req_loan_amt <= 5000000">
              <p class="card-text">The following shall be required for loan requests not more than PhP5.0 million during evaluation:</p>
              <div class="card-body mt-n3">
                <ul style="list-style: '-  '; margin-left: -20px;">
                  <li>Proof of sales including bank statements;</li>
                  <li>Joint and Solidary Signature (JSS) (for corporations and partnerships); and,</li>
                  <li>Proof of value of fixed asset/s to be acquired (if loan purpose is fixed asset acquisition).</li>
                  <li>Certificate of Securities and Exchange Commission (SEC) Registration;</li>
                  <li>Certificate of Department of Trade and Industry (DTI) Registration; and,</li>
                  <li>Bureau of Internal Revenue (BIR)-filed Financial Statement.</li>
                </ul>
              </div>
            </div>

            <div class="modal-body" v-if="formLoan.req_loan_amt > 5000000">
              <p class="card-text">The following shall be required for loan requests not more than PhP5.0 million during evaluation:</p>
              <div class="card-body mt-n3">
                <ul style="list-style: '-  '; margin-left: -20px;">
                  <li>Proof of sales including bank statements;</li>
                  <li>Joint and Solidary Signature (JSS) (for corporations and partnerships); and,</li>
                  <li>Proof of value of fixed asset/s to be acquired (if loan purpose is fixed asset acquisition).</li>
                  <li>Certificate of Securities and Exchange Commission (SEC) Registration;</li>
                  <li>Certificate of Department of Trade and Industry (DTI) Registration;</li>
                  <li>Bureau of Internal Revenue (BIR)-filed Financial Statement;</li>
                  <li>Proof of ownership of real estate asset; and,</li>
                  <li>Proof of Government Valuation of real estate asset.</li>
                </ul>
              </div>
            </div>

            <div class="modal-footer">
              <button data-dismiss="modal" class="btn btn-outline-primary"><i class="fas fa-times mr-1"></i>Cancel</button>
              <button type="button" class="btn btn-primary" @click="submitLoanAmount">Next<i class="fas fa-arrow-right ml-1"></i></button>
            </div>
          </div>
        </div>
      </div>

    </div>

  </transition>
</template>
<script>
  import moment from "moment";
  import {
    required,
    minLength,
    requiredIf
  } from "vuelidate/lib/validators";

  import {
    apiRefLoanInfoRegistry,
    apiPostLoanInfo,
    apiGetLoanInfoRegistry,
    apiDiscontinueRiseUp
  } from "@js/api/applyLoanApi";

  export default {
    props: ["formLoan"],
    data() {
      return {
        formLoanInfo: {
          application_id: null,
          loan_facility_id: null,
          coll_id: null,
          fund_id: null,
          loan_type_id: null,
        },

        readonly: true,
        req_loan_amt: false,
        period: [0, 3, 6],
        term: [12, 24, 36],

        types: [],
        facilities: [],
        collaterals: [],
        sources: [],
        submitting: false,

        option_curr: {
          currency: "USD",
          currencyDisplay: 'hidden',
          valueRange: {
            min: 0,
            max: 10000000
          }
        },

      };
    },
    validations: {
      formLoan: {
        req_loan_amt: {
          required,
        },
        req_loan_term: {
          required,
        },
        grace_period: {
          required
        },
      },
      formLoanInfo: {
        loan_facility_id: {
          required,
        },
        fund_id: {
          required,
        },
        loan_type_id: {
          required,
        },
      },

    },
    created() {
      this.evalLoan();
      this.initData();
    },
    mounted() {},
    methods: {
      selectLoanType(val) {
        if (val == 1) {
          this.formLoanInfo.coll_id = 1;
        } else {
          this.formLoanInfo.coll_id = null;
        }
      },

      async apiSubmit() {
        this.$emit('load', 1);
        try {
          const form = {
            application_id: this.formLoan.application_id,
            loan_facility_id: this.formLoanInfo.loan_facility_id,
            coll_id: this.formLoanInfo.coll_id,
            fund_id: this.formLoanInfo.fund_id,
            loan_type_id: this.formLoanInfo.loan_type_id,

            req_loan_amt: this.formLoan.req_loan_amt,
            req_loan_term: this.formLoan.req_loan_term,
            grace_period: this.formLoan.grace_period,
            interest_rate_pa: this.formLoan.interest_rate_pa,
            install_fee: this.formLoan.install_fee,
            repayment_mode: 4,
          };
          const res = await apiPostLoanInfo(form);
          this.$emit('next');
        } catch (error) {
          this.$emit('error', error);
        } finally {
          this.$emit('load', -1);
        }
      },

      async initData() {
        this.$emit('load', 1);
        try {
          const {
            collaterals,
            facilities,
            sources,
            types
          } = await apiRefLoanInfoRegistry();

          this.collaterals = collaterals;
          this.facilities = facilities;
          this.sources = sources;
          this.types = types;

          const data = await apiGetLoanInfoRegistry(this.formLoan.application_id);
          if (data && Object.keys(data).length > 0) {
            this.formLoanInfo = data;
          }

        } catch (error) {
          this.$emit('error', error);
        } finally {
          this.$emit('load', -1);
        }
      },
      changeLoanTerm() {
        this.formLoan.install_fee = null;
      },
      evalLoan() {
        this.formLoanInfo.loan_facility_id = 2;
      },

      next() {
        this.submitting = false;
        this.submitting = true;
        this.formLoan.install_fee = this.install_fee;
        this.$v.formLoan.$touch();
        this.$v.formLoanInfo.$touch();

        if (this.$v.formLoan.$invalid || this.$v.formLoanInfo.$invalid) {
          const err = {
            response: {
              data: {
                message: "Please complete all required fields",
              }
            }
          };
          this.$emit('error', err);
        } else {
          this.checkLoanAmount();
        }
      },
      thousands_separators(num) {
        if (num) {
          let num_parts = num.toString().split(".");
          num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return num_parts.join(".");
        }
      },

      submitLoanAmount() {
        $("#modalFPA").modal("hide");
        if (this.formLoan.req_loan_amt > 100000) {
          Swal.fire({
            icon: "info",
            html: '<p class="fs-18 mb-0"><b>ISANG PAALALA:</b></p>' +
              '<p class="fs-16 mx-n2">Kung sakaling ang inyong aplikasyon ay ganap na maaprubahan, kakailanganin magsumite ng Post Dated Cheques (PDCs) kasama ng iba pang mga requirements at naayon na kundisyones bago pa man tuluyang matanggap ang inyong CARES loan.</p>' +
              '<hr><p class="fs-18 mb-0"><b>IMPORTANT NOTICE:</b></p>' +
              '<p class="fs-16 mx-n2">(Should your loan application be approved, you shall be required to provide/issue Post Dated Cheques (PDCs) in addition to all other requirements and conditions prior to loan release.)</p>',
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonText: "Continue",
            cancelButtonText: "Cancel",
            reverseButtons: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.apiSubmit()
            }
          });
        } else {
          this.apiSubmit()
        }
      },

      async discontinueApp() {
        try {
          this.$emit('load', 1);
          const res = await apiDiscontinueRiseUp(this.formLoan.application_id);
          this.$router.push('/apply-loan');
        } catch (error) {
          this.$emit('error', error);
        } finally {
          this.$emit('load', -1);
        }
      },
      checkLoanAmount() {
        let loanAmount = this.formLoan.req_loan_amt * 1;
        let maxLoan = this.formLoan.max_loan * 1;
        let amount = this.thousands_separators(maxLoan);
        let minLoan = 50000;
        if (loanAmount < minLoan) {
          Swal.fire({
            icon: 'info',
            html: `Minimum Loan: <b>Php 50,000</b>`,
            allowOutsideClick: false
          }).then((response) => {
            this.formLoan.req_loan_amt = null;
          })

        } else {
          if (loanAmount > maxLoan) {
            Swal.fire({
              icon: "info",
              title: "Reminder",
              html: `Maximum Loan: <b>Php ${amount}</b>`,
              allowOutsideClick: false,
            }).then((response) => {
              this.formLoan.req_loan_amt = null;
            });
          } else {
            this.submitLoanAmount();
          }
        }
      },
      handler($event) {
        if (this.readonly) {
          $event.preventDefault();
        }
      },
    },
    computed: {
      arrGracePeriod() {
        let term = this.formLoan.req_loan_term;
        const lookup = {
          12: [0, 3, 6],
          24: [0, 3, 6, 9, 12],
          36: [0, 3, 6, 9, 12],
        };
        return lookup[term] || [];
      },
      convertedAmount() {
        let val = this.formLoan.req_loan_amt;
        if (val > 0) {
          let num_parts = val.toString().split(".");
          num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return num_parts.join(".");
        } else {
          return '';
        }
      },
      install_fee() {
        let x = '-';
        let g = this.formLoan.grace_period;
        let t = this.formLoan.req_loan_term;
        if (!this.formLoan.install_fee) {
          if (typeof t === 'number' && typeof g === 'number') {
            x = t - g;
          }
        } else {
          x = this.formLoan.install_fee;
        }
        return x;
      },
    },
  };
</script>



<style scoped>
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
  .div-control {
    display: block;
    width: 100%;
    padding: .2em .75rem;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.1;
    font-style: italic;
    color: #495057;
    background-color: #e9ecef;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    box-shadow: inset 0 0 0 transparent;
    transition: border-color .15s ease-in-out, box-shadow .15s
  }
</style>